import React from 'react';
import { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import {
  MediaDisplayer, MediaEventHandlers, Metadata, PhotoControls,
} from './media-displayer';
import AudioThumbnail from './audio-thumbnail';
import Audio from '../audio';
import { mapView, metadataView, noop } from './track-media-displayer';

const audioDisplayer: MediaDisplayer = {
  display(metadata: Metadata, handlers?: MediaEventHandlers & PhotoControls): React.ReactElement {
    return (
      <Audio
        src={metadata.medium || metadata.original}
        onPlay={handlers?.onPlay || noop}
        onPause={handlers?.onPause || noop}
        onTimeUpdate={handlers?.onTimeUpdate || noop}
        onSeeked={handlers?.onSeeked || noop}
        onSeeking={handlers?.onSeeking || noop}
        onError={handlers?.onError || noop}
        initialTime={metadata.initialTime || 0}
        seekTime={metadata.seekTime || 0}
      />
    );
  },
  thumbnail(
    item: MediaItemValue,
    onClick: (item: MediaItemValue) => void,
    extraStyles: React.CSSProperties,
  ): React.ReactElement {
    return (
      <AudioThumbnail
        item={item}
        styles={extraStyles}
        handleClick={() => onClick(item)}
      />
    );
  },
  mapView,
  metadata: metadataView,
};

export default audioDisplayer;
